import { Tooltip, Typography } from "@mui/material";
import { format } from "date-fns";
import { FedReference } from "./types";

interface Props {
  fedReferences: FedReference[] | undefined;
}

const formatAmount = (amount: number | null) =>
  amount == null ? "" : amount.toLocaleString("en-US", { style: "currency", currency: "USD" });

// Shown under a Funded status: the wire's Fed reference, or a warning while the bank hasn't released it
const FedReferenceLine = ({ fedReferences }: Props) => {
  if (!fedReferences) return null;

  if (fedReferences.length === 0) {
    return (
      <Typography variant="caption" display="block" color="warning.main" fontWeight={600}>
        Fed ref: not yet released
      </Typography>
    );
  }

  return (
    <>
      {fedReferences.map((f) => (
        <Tooltip
          key={f.reference}
          title={`${formatAmount(f.amount)} sent ${format(new Date(f.sentAt), "MMM d, yyyy h:mm a")}`}
          placement="bottom-start"
        >
          <Typography variant="caption" display="block" color="text.secondary" sx={{ userSelect: "all" }}>
            Fed ref: {f.reference}
          </Typography>
        </Tooltip>
      ))}
    </>
  );
};

export default FedReferenceLine;
